import React from 'react';
import { useSelector } from 'react-redux';


import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

// components importing
import OK from './ok';
import NotOK from './notOK';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2
};

export default function BasicModal(props: any) {

  // TODO: take props
  const open = props.open;
  const handleClose = props.handleClose;

  // TODO:
  const data = useSelector((state: any) => state.appReducer.data);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {data.isNotAnswerYet === true ? <NotOK handleClose={handleClose} /> : <OK handleClose={handleClose} />}
        </Box>
      </Modal>
    </div>
  );
}
